import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CommonSharedModule } from '../../shared/common-shared.module';
import { SideMainNavComponent } from './side-main-nav.component';
import { MenuListItemComponent } from './ui/menu-list-item/menu-list-item.component';

@NgModule({
  declarations: [
    SideMainNavComponent,
    MenuListItemComponent,
  ],
  exports: [
    SideMainNavComponent,
    MenuListItemComponent
  ],
  imports: [
    CommonSharedModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    // FaqModalModule,
    SweetAlert2Module
  ]
})
export class SideMainNavModule { }
